import { Grid } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(Grid)`
  .title {
    text-align: center;
    font-size: 18px;
  }
  .description {
    color: gray;
    font-size: 18px;
    font-family: 'Lanna';
    text-align: center;
  }
  .fa-telescope {
    font-size: 90px;
    fill: ${(props: any) => props.theme.palette.primary.light};
    color: ${(props: any) => props.theme.palette.primary.light};
  }
`);
